import moment from 'moment';

export function formatDate(date: string, format = 'll') {
  return moment(date).format(format);
}

export function htmlToPlainText(text: string) {
  return text.replace(/<[^>]+>/g, '');
}

export const truncateRichText = (text: string, maxLength = 135) => {
  // Remove HTML tags
  const plainText = htmlToPlainText(text);

  // Truncate the plain text
  const truncatedText = plainText.length > maxLength ? plainText.substring(0, maxLength) + '...' : plainText;

  return truncatedText;
};
